import { render, staticRenderFns } from "./TagsDropdownValues.vue?vue&type=template&id=a323be74&scoped=true&"
import script from "./TagsDropdownValues.vue?vue&type=script&lang=js&"
export * from "./TagsDropdownValues.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdownValues.vue?vue&type=style&index=0&id=a323be74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a323be74",
  null
  
)

export default component.exports